import { render, staticRenderFns } from "./EditKostenersatzGrid.vue?vue&type=template&id=707b1d6b&scoped=true"
import script from "./EditKostenersatzGrid.vue?vue&type=script&lang=ts"
export * from "./EditKostenersatzGrid.vue?vue&type=script&lang=ts"
import style0 from "./EditKostenersatzGrid.vue?vue&type=style&index=0&id=707b1d6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b1d6b",
  null
  
)

export default component.exports